import { useEffect, useState } from 'react';
import {
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  withStyles
} from '@material-ui/core';
import Label from './common/Label';
import { getDataWithQueryString } from '../../../../../api/componentAPIs';
import { sortBy } from 'lodash';

const CustomTableCell = withStyles((theme) => ({
  head: {
    fontWeight: 600,
    color: theme.TextColor,
    paddingLeft: 8
  },
  body: {
    fontSize: theme.textFontSize,
    border: `1px solid ${theme.AppBGColor}`,
    padding: 4,
    paddingLeft: 8,
    color: theme.gridTextColor
  }
}))(TableCell);

const styles = (theme) => ({
  tableHead: {
    backgroundColor: theme.AppBGColor
  },
  table: {
    margin: 0,
    width: '100%'
  },
  descCell: {
    width: '70%',
    borderRight: 'none'
  },
  codeCell: {
    borderLeft: 'none'
  },
  tableRow: {
    height: 32
  },
  tableRowHead: {
    border: `1px solid ${theme.AppBGColor}`
  },
  title: {
    margin: '16px 0px'
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    margin: '16px 0px',
    fontSize: theme.textFontSize,
    alignItems: 'center'
  }
});

const getFormattedFreightDetails = (freightBillDetails) => {
  return freightBillDetails.map((bill) => ({
    description: bill.freightDescription,
    code: bill.code
  }));
};

const ShipmentInfo = ({ classes, shipmentId, freightBillDetailsApi, freightBillDetailsQueryParams }) => {
  const [freightBillData, setFreightBillData] = useState([]);
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    if (shipmentId) {
      getDataWithQueryString(freightBillDetailsApi, freightBillDetailsQueryParams).then(
        (response) => {
          setLoading(false);
          if (response && response.status === 200) {
            setFreightBillData(
              getFormattedFreightDetails(sortBy(response.data[0]?.freightBillDetails, 'sequence'))
            );
          }
        },
        (_err) => {
          setLoading(false);
        }
      );
    } else {
      setFreightBillData([]);
      setLoading(false);
    }
  }, [shipmentId]);
  return (
    <>
      <div className={classes.title}>
        <Label labelText="Shipment Info" />
      </div>
      {isLoading ? (
        <div className={classes.loadingContainer}>
          <CircularProgress size={20} />
        </div>
      ) : (
        <Table className={classes.table}>
          <TableHead className={classes.tableHead}>
            <TableRow className={`${classes.tableRow} ${classes.tableRowHead}`}>
              <CustomTableCell align="left">Description</CustomTableCell>
              <CustomTableCell align="left">Code</CustomTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {freightBillData.map((row) => (
              <TableRow key={row.id} className={classes.tableRow}>
                <CustomTableCell align="left" className={classes.descCell}>
                  {row.description}
                </CustomTableCell>
                <CustomTableCell align="left" className={classes.codeCell}>
                  {row.code}
                </CustomTableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </>
  );
};

export default withStyles(styles)(ShipmentInfo);
